module.exports = __webpack_public_path__ + "static/media/36.69564e03.mp3";